import React from "react";
import get from "lodash/get";
import {
  Button,
  Icon,
  Form,
  Input,
  Select,
  Popconfirm,
  Collapse,
  Row,
  Col,
} from "antd";
import { Draggable, Droppable } from "react-beautiful-dnd";

const NextRulesContainer = ({
  form,
  event,
  getEventDraggableId,
  getEventDroppableId,
  getEventFieldName,
  rules,

  onAddQuestionNextRuleRequested,
  onRemoveQuestionNextRuleRequested,
}) => (
  <Collapse
    defaultActiveKey={get(event, "next_rules", []).length > 0 ? 1 : undefined}
  >
    <Collapse.Panel key={1} header="Next rules">
      <Droppable
        droppableId={getEventDroppableId(event, "rules")}
        type="event-next-rules"
      >
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {get(event, "next_rules", []).map((rule, ruleIndex) => {
              const draggableId = getEventDraggableId(
                event,
                `rule::${ruleIndex}`
              );
              return (
                <Draggable
                  key={draggableId}
                  draggableId={draggableId}
                  index={ruleIndex}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Row gutter={8}>
                        <Col xs={10}>
                          <Form.Item
                            label="Condition"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            {form.getFieldDecorator(
                              getEventFieldName(
                                event,
                                `next_rules[${ruleIndex}].if`
                              ),
                              {
                                initialValue: get(
                                  event,
                                  `next_rules[${ruleIndex}].if`,
                                  null
                                ),
                              }
                            )(
                              <Select>
                                {rules.map((rule) => (
                                  <Select.Option value={rule.if || null}>
                                    {rule.label}
                                  </Select.Option>
                                ))}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                        <Col xs={10}>
                          <Form.Item
                            label="Target id"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            {form.getFieldDecorator(
                              getEventFieldName(
                                event,
                                `next_rules[${ruleIndex}].id`
                              ),
                              {
                                initialValue: get(
                                  event,
                                  `next_rules[${ruleIndex}].id`
                                ),
                              }
                            )(<Input />)}
                          </Form.Item>
                        </Col>
                        <Col xs={4}>
                          <Form.Item>
                            <Popconfirm
                              onConfirm={() =>
                                onRemoveQuestionNextRuleRequested(
                                  event,
                                  ruleIndex
                                )
                              }
                              title="Do you really want to delete this rule?"
                              cancelText="No"
                              okText="Yes"
                            >
                              <Button type="danger">
                                <Icon type="delete" />
                              </Button>
                            </Popconfirm>
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <Form.Item>
        <Button onClick={() => onAddQuestionNextRuleRequested(event)}>
          <Icon type="plus" />
          Add choice
        </Button>
      </Form.Item>
    </Collapse.Panel>
  </Collapse>
);

export default NextRulesContainer;
